import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import { format, parseISO } from 'date-fns';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiUser, FiMail, FiCreditCard, FiUserPlus, FiSave } = FiIcons;

const Settings = () => {
  const { parents, updateParent } = useApp();
  const [formData, setFormData] = useState({
    name: parents.name
  });
  const [isEditing, setIsEditing] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    updateParent({ name: formData.name.trim() });
    setIsEditing(false);
  };

  const handleCancel = () => {
    setFormData({ name: parents.name });
    setIsEditing(false);
  };

  return (
    <div className="space-y-6 max-w-2xl">
      <h1 className="text-3xl font-bold text-gray-800">Settings</h1>

      {/* Parent Account */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">Parent Account</h2>
        
        <div className="space-y-4">
          <div className="flex items-center space-x-3">
            <SafeIcon icon={FiMail} className="text-gray-400" />
            <div>
              <label className="block text-sm font-medium text-gray-700">Email</label>
              <p className="text-gray-600">{parents.email}</p>
              <p className="text-xs text-gray-500">Email cannot be changed</p>
            </div>
          </div>

          <div className="flex items-start space-x-3">
            <SafeIcon icon={FiUser} className="text-gray-400 mt-1" />
            <div className="flex-1">
              <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
              {isEditing ? (
                <form onSubmit={handleSubmit} className="space-y-3">
                  <input
                    type="text"
                    value={formData.name}
                    onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
                    className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                    required
                  />
                  <div className="flex space-x-2">
                    <button
                      type="submit"
                      className="flex items-center space-x-1 bg-purple-600 text-white px-3 py-1 rounded text-sm hover:bg-purple-700 transition-colors"
                    >
                      <SafeIcon icon={FiSave} />
                      <span>Save</span>
                    </button>
                    <button
                      type="button"
                      onClick={handleCancel}
                      className="bg-gray-600 text-white px-3 py-1 rounded text-sm hover:bg-gray-700 transition-colors"
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              ) : (
                <div className="flex items-center justify-between">
                  <p className="text-gray-600">{parents.name}</p>
                  <button
                    onClick={() => setIsEditing(true)}
                    className="text-purple-600 hover:text-purple-700 text-sm"
                  >
                    Edit
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Subscription Info */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">Subscription</h2>
        
        <div className="space-y-4">
          <div className="flex items-center space-x-3">
            <SafeIcon icon={FiCreditCard} className="text-gray-400" />
            <div>
              <label className="block text-sm font-medium text-gray-700">Plan</label>
              <p className="text-gray-600">{parents.subscription}</p>
            </div>
          </div>

          <div className="flex items-center space-x-3">
            <div className="w-5"></div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Renewal Date</label>
              <p className="text-gray-600">
                {format(parseISO(parents.renewalDate), 'dd/MM/yyyy')}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Co-Parent (Placeholder) */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">Co-Parent Access</h2>
        
        <div className="text-center py-6">
          <SafeIcon icon={FiUserPlus} className="text-4xl text-gray-300 mx-auto mb-3" />
          <h3 className="text-lg font-medium text-gray-700 mb-2">Invite Co-Parent</h3>
          <p className="text-gray-500 mb-4">
            Share access with your partner to track sleep together
          </p>
          <button
            disabled
            className="bg-gray-300 text-gray-500 px-4 py-2 rounded-lg cursor-not-allowed"
          >
            Coming Soon
          </button>
        </div>
      </div>
    </div>
  );
};

export default Settings;